module.exports = __webpack_public_path__ + "img/error-404-xl.ecf26749.jpg";